import { useState, useEffect } from "react";

export default function PayPage() {
  const [txt, setTxt] = useState("در حال انتقال به درگاه پرداخت ...");
  useEffect(() => {
    setTimeout(() => {
      setTxt("متاسفانه مشکلی در درگاه پرداخت پیش آمده است.");
    }, 6000);
  }, []);
  return (
    <div className="d-flex">
      <h4 className={`mx-auto mt-4`}>{txt}</h4>
    </div>
  );
}
